import defaultTemplates from "../Organizations/Default/registry.js";
import dmrTemplates from "../Organizations/Dmr/registry.js";
import fabTemplates from "../Organizations/Fab/registry.js";
import sunsetTemplates from "../Organizations/SunsetMadness/registry.js";
import wbbTemplates from "../Organizations/Wbb/registry.js";

const templateRegistry = {
 ...defaultTemplates,
 ...dmrTemplates,
 ...fabTemplates,
 ...sunsetTemplates,
 ...wbbTemplates,
};

export const HOMEPAGE_TEMPLATE_OPTIONS = Object.values(templateRegistry)
 .filter((template) => template.pageType === "home")
 .map(({ id, name, desc, pageType }) => ({
  id,
  name,
  desc,
  pageType,
 }));

export const PAGE_TEMPLATE_OPTIONS = Object.values(templateRegistry).map(
 ({ id, name, desc, pageType }) => ({
  id,
  name,
  desc,
  pageType,
 })
);

export const MANAGEABLE_TEMPLATE_OPTIONS = Object.values(templateRegistry)
 .filter((template) => !template.id.startsWith("default-"))
 .map(({ id, label, desc, pageType }) => ({
  id,
  label,
  desc,
  pageType,
 }));

export default templateRegistry;